import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { publicApi } from '../utils/api';
import { LandingPage } from './LandingPage';
import { CMSPublicPage } from './CMSPublicPage';

/**
 * Smart `/` route — admin-configurable home.
 *
 * Renders the CMS `home` page if it exists, is published, and has at least
 * one visible block. Otherwise falls back to the hand-coded marketing
 * <LandingPage/> so the site is never blank.
 *
 * Admins control the entire home page from /admin/cms → Home Page.
 */
export function HomeRoute() {
  const [state, setState] = useState({ loading: true, useCms: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await publicApi.get('/api/cms/pages/home');
        const blocks = Array.isArray(data?.section_data) ? data.section_data : [];
        const visibleCount = blocks.filter((b) => b?.is_visible !== false).length;
        const usable = !!data?.is_published && visibleCount > 0;
        if (!cancelled) setState({ loading: false, useCms: usable });
      } catch {
        if (!cancelled) setState({ loading: false, useCms: false });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (state.loading) {
    return (
      <div className="min-h-screen bg-[#000B18] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#00E5FF]" />
      </div>
    );
  }

  return state.useCms ? <CMSPublicPage slug="home" /> : <LandingPage />;
}

export default HomeRoute;
